<template>
    <div class="android_setting_base">
        <span>端末に適用する制限を設定してください。</span>
        <!-- 記憶媒体／データ転送 -->
        <div class="android_setting_main">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">記憶媒体／データ転送</div>
            </div>
            <div class="android_setting_sub">
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_mountPhysicalMediaDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.mountPhysicalMediaDisabled"
                           @change="onChange" />
                    <label for="chk_mountPhysicalMediaDisabled" class="scv-check-label">メディア（MicroSDカード等）の利用を禁止する</label>
                </div>
                <ThreeStateToggle
                    ref="chk_usbFileTransferDisabledState"
                    v-model="policyRef.policy.deviceConnectivityManagement!.usbDataAccess"
                    :disabled="disabled" 
                    id="chk_usbFileTransferDisabled"
                    :caption = "chk_usbFileTransferDisabledCaption"
                    :trueValue = "chk_usbFileTransferDisabledTrueValue"
                    :falseOptions = "chk_usbFileTransferDisabledFalseOptions"
                    @changeState="onChange"
                />
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_outgoingBeamDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.outgoingBeamDisabled"
                           @change="onChange" />
                    <label for="chk_outgoingBeamDisabled" class="scv-check-label">NFCによるデータ転送を禁止する</label>
                </div>
            </div>
        </div>

        <!-- 機能 -->
        <div class="android_setting_main">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">機能</div>
            </div>
            <div class="android_setting_sub">
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_cameraAccess"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_cameraAccess"
                           @change="onChangeCaneraAccess" />
                    <label for="chk_cameraAccess" class="scv-check-label">カメラの利用を禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_screenCaptureDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.screenCaptureDisabled"
                           @change="onChange" />
                    <label for="chk_screenCaptureDisabled" class="scv-check-label">スクリーンショットを禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_smsDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.smsDisabled"
                           @change="onChange" />
                    <label for="chk_smsDisabled" class="scv-check-label">ショートメッセージサービス（SMS）の利用を禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_tetheringConfigDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.tetheringConfigDisabled"
                           @change="onChange" />
                    <label for="chk_tetheringConfigDisabled" class="scv-check-label">テザリングを禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_bluetoothDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.bluetoothDisabled"
                           @change="onChange" />
                    <label for="chk_bluetoothDisabled" class="scv-check-label">Bluetoothの利用を禁止する</label>
                </div>
            </div>
        </div>

        <!-- 端末設定 -->
        <div class="android_setting_main">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">端末設定</div>
            </div>
            <div class="android_setting_sub">
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_factoryResetDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.factoryResetDisabled"
                           @change="onChange" />
                    <label for="chk_factoryResetDisabled" class="scv-check-label">端末のリセット（すべてのデータの消去）を禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_networkResetDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.networkResetDisabled"
                           @change="onChange" />
                    <label for="chk_networkResetDisabled" class="scv-check-label">Wi-Fi、モバイル、Bluetoothのリセットを禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_autoDateAndTimeZone"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_autoDateAndTimeZone"
                           @change="onChangeAutoDateAndTimeZone" />
                    <label for="chk_autoDateAndTimeZone" class="scv-check-label">日付と時刻の変更を禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_locationMode"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_locationEnable"
                           @change="onChangeLocationEnable" />
                    <label for="chk_locationMode" class="scv-check-label">位置情報の無効化を禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_stayOnPluggedModes"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_stayOnPluggedModes"
                           @change="onChangeStayOnPluggedModes" />
                    <label for="chk_stayOnPluggedModes" class="scv-check-label">充電中の自動的なスリープを禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_developerSettings"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_developerSettings"
                           @change="onChangeDeveloperSettings" />
                    <label for="chk_developerSettings" class="scv-check-label">開発者向けオプションを禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_addUserDisabled"
                           v-bind:disabled="disabled"
                           v-model="policyRef.policy.addUserDisabled"
                           @change="onChange" />
                    <label for="chk_addUserDisabled" class="scv-check-label">複数ユーザー設定の利用を禁止する</label>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_modifyAccountsDisabled"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_modifyAccountsDisabled"
                           @change="onChangeModifyAccountsDisabled" />
                    <label for="chk_modifyAccountsDisabled" class="scv-check-label">アカウントの追加／削除を禁止する</label>
                </div>
                <div class="android_setting_sub_btn">
                    <div class="d-flex align-items-center">
                        <div>
                            <label class="scv-check-label-box">
                                <input class="scv-check-label"
                                       type="radio"
                                       name="rdo_modifyAccountsDisabled"
                                       v-bind:disabled="disabled || !chkbtn_modifyAccountsDisabled"
                                       v-model="rdobtn_modifyAccountsDisabled"
                                       @change="onChangeModifyAccountsDisabled"
                                       :value="0">
                                <span>Googleアカウントのみ禁止する</span>
                            </label>
                        </div>
                        <div class="android_setting_item_horizontal_margine">
                            <label class="scv-check-label-box">
                                <input class="scv-check-label"
                                       type="radio"
                                       name="rdo_modifyAccountsDisabled"
                                       v-bind:disabled="disabled || !chkbtn_modifyAccountsDisabled"
                                       v-model="rdobtn_modifyAccountsDisabled"
                                       @change="onChangeModifyAccountsDisabled"
                                       :value="1">
                                <span>すべてのアカウントを禁止する</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="scv-check-box">
                    <input type="checkbox"
                           id="chk_privateKeySelectionDisabled"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_privateKeySelectionDisabled"
                           @change="onChangePrivateKeySelectionDisabled" />
                    <label for="chk_privateKeySelectionDisabled" class="scv-check-label">VPNとアプリユーザー証明書の利用を禁止する</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { AndroidPolicyWrapper } from '@/models/Mobile/Android/AndroidPolicyWrapper'
    import { AMAPI_AdvancedSecurityOverrides } from '@/models/Mobile/Android/AndroidManagementV1Schema';
    import ThreeStateToggle from '@/views/Mobile/Android/ThreeStateToggle.vue';
    import * as schemaConstants from '@/models/Mobile/Android/AndroidManagementV1SchemaConstants'
    @Options({
        props: {
            disabled: { type: Boolean, Default: false },   /* 強制的にボタンをDisableにする*/
        },
        components: {
            ThreeStateToggle
        },
        emits: ['notifyUpdate'],
    })

    export default class AndroidLimitSetting extends Vue {
        private policyRef = AndroidPolicyWrapper.convertDeprecatedPolicy(new AndroidPolicyWrapper());

        private readonly def_LOCATION_ENFORCED = "LOCATION_ENFORCED";
        private readonly def_CAMERA_ACCESS_DISABLED = "CAMERA_ACCESS_DISABLED";
        private readonly def_AUTO_DATE_AND_TIME_ZONE_ENFORCED = "AUTO_DATE_AND_TIME_ZONE_ENFORCED";
        private readonly def_AC = "AC";
        private readonly def_USB = "USB";
        private readonly def_WIRELESS = "WIRELESS";
        private readonly def_DEVELOPER_SETTINGS_ALLOWED = "DEVELOPER_SETTINGS_ALLOWED";

        private chkbtn_cameraAccess = false;
        private chkbtn_locationEnable = false;
        private chkbtn_autoDateAndTimeZone = false;
        private chkbtn_stayOnPluggedModes = false;
        private chkbtn_developerSettings = true;
        private chkbtn_modifyAccountsDisabled = false;
        private rdobtn_modifyAccountsDisabled = 0;
        private chkbtn_privateKeySelectionDisabled = false;
  
        private readonly chk_usbFileTransferDisabledCaption = 'USBによるデータ転送／記憶媒体の利用を制限する';
        private readonly chk_usbFileTransferDisabledTrueValue = schemaConstants.AMAPI_UsbDataAccess_Enums.allowUsbDataTransfer;
        private readonly chk_usbFileTransferDisabledFalseOptions = [
            { 
                label: 'ファイル転送／記憶媒体の利用のみ禁止する', 
                value: schemaConstants.AMAPI_UsbDataAccess_Enums.disAllowUsbFileTransfer, 
                information:undefined,
                change:undefined
            },
            {
                label: '充電以外の利用を禁止する（Android 12以降）', 
                value: schemaConstants.AMAPI_UsbDataAccess_Enums.disAllowUsbDataTransfer, 
                information:"<div>Android 12未満の端末には「ファイル転送／記憶媒体の利用のみ禁止する」が適用されます。<br/>※Android 12以降でも一部の端末（USB HAL 1.3未満）では、「ファイル転送／記憶媒体の利用のみ禁止する」が適用されます。</div>",
                change:"Android 12未満の端末には「ファイル転送／記憶媒体の利用のみ禁止する」が適用されます。<br/>※Android 12以降でも一部の端末（USB HAL 1.3未満）では、「ファイル転送／記憶媒体の利用のみ禁止する」が適用されます。"
            }
        ];
  
        // private readonly credentialProviderPolicyDefaultCaption = 'デフォルトの認証情報マネージャーアプリケーションの利用を許可する';
        // private readonly credentialProviderPolicyDefaultTrueValue = schemaConstants.AMAPI_CredentialProviderPolicyDefault_Enums.credentialProviderDefaultDisallowedExceptSystem;
        // private readonly credentialProviderPolicyDefaultFalseValue = schemaConstants.AMAPI_CredentialProviderPolicyDefault_Enums.credentialProviderDefaultDisallowed;

        /**
         *  UIのリセット
         */
        private resetUI() {
            this.chkbtn_cameraAccess = false;
            this.chkbtn_locationEnable = false;
            this.chkbtn_autoDateAndTimeZone = false;
            this.chkbtn_stayOnPluggedModes = false;
            this.chkbtn_developerSettings = true;
            this.chkbtn_modifyAccountsDisabled = false;
            this.rdobtn_modifyAccountsDisabled = 0;
            this.chkbtn_privateKeySelectionDisabled = false;

            const refObj: any = this.$refs;
            refObj.chk_usbFileTransferDisabledState?.resetSelectState();
        }

        /**
         *  ポリシーの参照をセット
         */
        public setPolicyRef(policy: AndroidPolicyWrapper): void {
            // ローカル値を更新する
            this.resetUI();
            this.$nextTick(() => {
                this.policyRef = policy;

                this.updateCaneraAccess();
                this.updateLocationEnable();
                this.updateAutoDateAndTimeZone();
                this.updateStayOnPluggedModes();
                this.updateDeveloperSettings();
                this.updateModifyAccountsDisabled();
                this.updatePrivateKeySelectionDisabled();
            });
        }

        /**
         *  変更ハンドラ
         */
        public onChange(): void {
            this.$emit('notifyUpdate');
        }

        /**
         *  カメラの利用を禁止する
         */
        private onChangeCaneraAccess(): void {

            this.policyRef.policy.cameraAccess = this.chkbtn_cameraAccess ? this.def_CAMERA_ACCESS_DISABLED : null;

            this.onChange();
        }
        private updateCaneraAccess(): void {

            // 変更がある場合のみ設定
            if (this.def_CAMERA_ACCESS_DISABLED == this.policyRef.policy.cameraAccess) {
                this.chkbtn_cameraAccess = true;
            }
        }

        /**
         *  日付と時刻の変更を禁止する
         */
        private onChangeAutoDateAndTimeZone(): void {

            this.policyRef.policy.autoDateAndTimeZone = this.chkbtn_autoDateAndTimeZone ? this.def_AUTO_DATE_AND_TIME_ZONE_ENFORCED : null;

            this.onChange();
        }
        private updateAutoDateAndTimeZone(): void {

            // 変更がある場合のみ設定
            if (this.def_AUTO_DATE_AND_TIME_ZONE_ENFORCED == this.policyRef.policy.autoDateAndTimeZone) {
                this.chkbtn_autoDateAndTimeZone = true;
            }
        }

        /**
         *  位置情報の無効化を禁止する
         */
        private onChangeLocationEnable(): void {

            this.policyRef.policy.locationMode = this.chkbtn_locationEnable ? this.def_LOCATION_ENFORCED : null;

            this.onChange();
        }
        private updateLocationEnable(): void {

            // 変更がある場合のみ設定
            if (this.def_LOCATION_ENFORCED == this.policyRef.policy.locationMode) {
                this.chkbtn_locationEnable = true;
            }
        }

        /**
         *  充電中の自動的なスリープを禁止する
         */
        private onChangeStayOnPluggedModes(): void {

            this.policyRef.policy.stayOnPluggedModes = new Array<string>();

            if (this.chkbtn_stayOnPluggedModes) {
                this.policyRef.policy.stayOnPluggedModes.push(this.def_AC);
                this.policyRef.policy.stayOnPluggedModes.push(this.def_USB);
                this.policyRef.policy.stayOnPluggedModes.push(this.def_WIRELESS);
            }
            else {
                this.policyRef.policy.stayOnPluggedModes = null;
            }

            this.onChange();
        }
        private updateStayOnPluggedModes(): void {

            if (undefined == this.policyRef.policy.stayOnPluggedModes ||
                null == this.policyRef.policy.stayOnPluggedModes) {
                return;
            }

            // 変更がある場合のみ設定
            if (0 < this.policyRef.policy.stayOnPluggedModes.length) {
                this.chkbtn_stayOnPluggedModes = true;
            }
        }

        /**
         *  開発者向けオプションを禁止する
         */
        private onChangeDeveloperSettings(): void {

            if (undefined == this.policyRef.policy.advancedSecurityOverrides) {
                this.policyRef.policy.advancedSecurityOverrides = new AMAPI_AdvancedSecurityOverrides();
            }

            if (this.chkbtn_developerSettings) {
                this.policyRef.policy.advancedSecurityOverrides.developerSettings = null;
            }
            else {
                this.policyRef.policy.advancedSecurityOverrides.developerSettings = this.def_DEVELOPER_SETTINGS_ALLOWED;
            }
            
            this.onChange();
        }
        private updateDeveloperSettings(): void {

            // デフォルトが有効なので設定が無ければ設定しておく
            if (undefined == this.policyRef.policy.advancedSecurityOverrides) {
                this.policyRef.policy.advancedSecurityOverrides = new AMAPI_AdvancedSecurityOverrides();
                this.policyRef.policy.advancedSecurityOverrides.developerSettings = null;
                return;
            }

            // 変更がある場合のみ設定
            if (undefined != this.policyRef.policy.advancedSecurityOverrides.developerSettings &&
                this.def_DEVELOPER_SETTINGS_ALLOWED == this.policyRef.policy.advancedSecurityOverrides.developerSettings) {
                this.chkbtn_developerSettings = false;
            }
        }

        /**
         *  アカウントの追加／削除を禁止する
         */
        private onChangeModifyAccountsDisabled(): void {

            // 使用する場合のみ下の条件で設定する
            delete this.policyRef.policy.modifyAccountsDisabled;
            delete this.policyRef.policy.accountTypesWithManagementDisabled;

            if (this.chkbtn_modifyAccountsDisabled) {
                if (0 == this.rdobtn_modifyAccountsDisabled) {
                    // Googleアカウントのみ
                    this.policyRef.policy.accountTypesWithManagementDisabled = new Array<string>();
                    this.policyRef.policy.accountTypesWithManagementDisabled.push("com.google");
                }
                else {
                    this.policyRef.policy.modifyAccountsDisabled = true;
                }
            }

            this.onChange();
        }
        private updateModifyAccountsDisabled(): void {

            // 変更がある場合のみ設定
            if (undefined != this.policyRef.policy.accountTypesWithManagementDisabled) {
                this.chkbtn_modifyAccountsDisabled = true;
            }
            else if (undefined != this.policyRef.policy.modifyAccountsDisabled){
                this.chkbtn_modifyAccountsDisabled = true;
                this.rdobtn_modifyAccountsDisabled = 1;
            }
        }

        /**
         *  VPNとアプリユーザー証明書の利用を禁止する
         */
        private onChangePrivateKeySelectionDisabled(): void {

            // 実際の設定とはあべこべ設定になる
            this.policyRef.policy.privateKeySelectionEnabled = !this.chkbtn_privateKeySelectionDisabled;

            this.onChange();
        }
        private updatePrivateKeySelectionDisabled(): void {

            /// 仕様変更や、その他の事情によるポリシーの変換処理
            /// ・ポリシーの仕様変更で廃止されたプロパティを代替プロパティに変換
            /// ・SKYSEAのバージョンアップなどで、AMAPIのデフォ値と異なる値を適用する
            if (undefined == this.policyRef.policy.privateKeySelectionEnabled) {
                this.policyRef.policy.privateKeySelectionEnabled = true;
                return;
            }

            // 実際の設定とはあべこべ設定になる
            this.chkbtn_privateKeySelectionDisabled = !this.policyRef.policy.privateKeySelectionEnabled;
        }
    }
</script>

<style>
    @import "../../../assets/css/setting.css";
    @import "../../../assets/css/MobileAndroidCommon.css";
</style>